import React from 'react';
import { useTranslation } from 'react-i18next';

const Sales = () => {
  const {t} = useTranslation()
  return (
    <div>
      {t('Sales')}
    </div>
  );
};

export default Sales;